import https from './index'
import qs from 'qs'

import  URLS from "./lz.js"



// URLS.FansGroupUrl = '/apitest'

// URLS.FansUpLoadUrl = '/apiupload'


//

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 查询用户的任务列表
 */
export function userTaskList(params) {
    return https({
        url:URLS.FansGroupUrl + '/task/userTaskList',
        method: "GET",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取经验值
 */
export function levelAndExp(params) {
    return https({
        url:URLS.rootApi + '/v1/profile/user/levelAndExp',
        method: "GET",
        params,
    })
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 查询活动列表
 */
export function configList(params) {
    return https({
        url:URLS.FansGroupUrl + '/activity/configList',
        method: "GET",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 查询宝箱任务列表
 */
export function treasureBoxlist(params) {
    return https({
        url:URLS.FansGroupUrl + '/treasureBox/list',
        method: "GET",
        authToken:true,
        params,
    })
}


// 上报时长

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 任务奖励领取
 */

export function treasureBoxReport(data) {
    return https({
        url:URLS.FansGroupUrl + '/treasureBox/viewReport',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 任务奖励领取
 */

export function taskacquireAward(data) {
    return https({
        url:URLS.FansGroupUrl + '/task/acquireAward',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 粉丝团礼物权益列表  -- 用户端

 */
export function userEquitiesGift(params) {
    return https({
        url:URLS.FansGroupUrl + '/fansClub/userEquitiesGift',
        method: "get",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 宝箱任务奖励领取
 */

export function acquireAward(data) {
    return https({
        url:URLS.FansGroupUrl + '/treasureBox/acquireAward',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 上报观看直播的时长
 */

export function viewReport(params) {
    return https({
        url:URLS.FansGroupUrl + '/treasureBox/viewReport',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 直播间发送推单
 */
export function roompublish(data) {
    return https({
        url:URLS.rootApi + '/v1/quiz/publish',
        method: "post",
        authToken:true,
        data,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 主播的粉丝团详情
 */
export function detailForUser(params) {
    return https({
        url:URLS.FansGroupUrl + '/fansClub/detailForUser',
        method: "get",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 加入
 */
export function fansClubjoin(data) {
    return https({
        url:URLS.FansGroupUrl + '/fansClub/join',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 图片上传
 */
export function fansGroupImgUpload(data) {
    return https({
        url:URLS.FansUpLoadUrl + '/file/fansGroupImgUpload',
        method: "post",
        authToken:true,
        updata:true,
        data,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 创建粉丝群
 */
export function fansGroupcreate(data) {
    return https({
       url:URLS.FansGroupUrl + '/fansGroup/create',
       method: "post",
       authToken:true,
       data:qs.stringify(data),
    })
}




/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 用户相关粉丝群
 */
export function userGroupList(params) {
    return https({
        url:URLS.FansGroupUrl + '/fansGroup/userGroupList',
        method: "get",
        authToken:true,
       params
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 未加入的粉丝群
 */
export function notJoinGroupList(params) {
    return https({
        url:URLS.FansGroupUrl + '/fansGroup/notJoinGroupList',
        method: "get",
        authToken:true,
       params
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 封单
 */
export function recommendblock(params) {
    return https({
        url:URLS.FansGroupUrl + '/recommend/block',
        method: "get",
        authToken:true,
       params
    })
}
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 解除封单
 */
export function recommendunblock(params) {
    return https({
        url:URLS.FansGroupUrl + '/recommend/unblock',
        method: "get",
        authToken:true,
       params
    })
}



/**
 *
 * @param {groupId}  房间ID  粉丝群id
 * @returns
 * @description 粉丝群发布推单
 */
export function publish(data) {
    return https({
        url:URLS.FansGroupUrl + '/recommend/publish',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}
// /v1/quiz/history

/**
 *
 * @param {groupId}  房间ID  粉丝群id
 * @returns
 * @description 粉丝群推单历史
 */
export function anchorRecommendList(params) {
    return https({
        url:URLS.FansGroupUrl + '/recommend/anchorRecommendList',
        method: "GET",
        authToken:true,
        params
        // data:qs.stringify(data),
    })
}


/**
 *
 * @param {groupId}  房间ID  粉丝群id
 * @returns
 * @description 用户已购订单列表
 */
export function userOrderList(params) {
    return https({
        url:URLS.FansGroupUrl + '/recommend/userOrderList',
        method: "GET",
        authToken:true,
        params
        // data:qs.stringify(data),
    })
}




/**
 *
 * @param {groupId}  房间ID  粉丝群id
 * @returns
 * @description 查询推单详情
 */
export function recommendDetail(params) {
    return https({
        url:URLS.FansGroupUrl + '/recommend/recommendDetail',
        method: "GET",
        authToken:true,
        params
        // data:qs.stringify(data),
    })
}
//
/**
 *
 * @param {groupId}  房间ID  粉丝群id
 * @returns
 * @description 结单
 */
export function overaccount(params) {
    return https({
        url:URLS.FansGroupUrl + '/recommend/account',
        method: "get",
        authToken:true,
        params,
    })
}
/**
 *
 * @param {groupId}  房间ID  粉丝群id
 * @returns
 * @description 购买推单
 */
export function recommendorder(data) {
    return https({
        url:URLS.FansGroupUrl + '/recommend/order',
        method: "post",
		    authToken:true,
        data:qs.stringify(data),
    })
}

//
/**
 *
 * @param {anchorUId} params
 * @returns
 * @description 观看时长
 * anchorUId:主播uid
 */
export function watchLive(params) {
    return https({
        url:URLS.FansGroupUrl + '/fansClub/watchLive',
        method: "get",
        params,
        authToken:true,
    })
}


/**
 *
 * @param {anchorUId} params
 * @returns
 * @description 用户与主播的粉丝团关联信息
 * anchorUId:主播uid
 */
export function userRelation(params) {
    return https({
        url:URLS.FansGroupUrl + '/fansClub/userRelation',
        method: "get",
        params,
        authToken:true,
    })
}



// WEBPACK FOOTER //
// ./src/api/fans.js